const returnModalStyles = {
  dialog: {
    '& .MuiDialog-paper': {
      background: 'white',
      borderRadius: '8px',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
      maxWidth: '600px',
      width: '100%',
      margin: 'auto',
    }
  },
  content: {
    padding: '0 !important',
    background: 'white',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 24px 16px',
  },
  title: {
    fontSize: '18px !important',
    fontWeight: '600 !important',
    color: '#333',
    margin: '0 !important',
  },
  closeButton: {
    padding: '4px !important',
    color: '#666 !important',
    '&:hover': {
      backgroundColor: '#f5f5f5 !important',
    }
  },
  body: {
    padding: '0px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    fontSize: '14px !important',
    fontWeight: '500 !important',
    color: '#333',
    marginBottom: '4px !important',
  },
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      background: 'white',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bdbdbd',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#2196f3',
        borderWidth: '2px',
      }
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 14px',
      fontSize: '14px',
      color: '#333',
    }
  },
  select: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      background: 'white',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bdbdbd',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#2196f3',
        borderWidth: '2px',
      }
    },
    '& .MuiSelect-select': {
      padding: '12px 14px',
      fontSize: '14px',
      color: '#333',
      '&:focus': {
        background: 'white',
      }
    }
  },
  textarea: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '6px',
      background: 'white',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#bdbdbd',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#2196f3',
        borderWidth: '2px',
      }
    },
    '& .MuiOutlinedInput-input': {
      padding: '12px 14px',
      fontSize: '14px',
      color: '#333',
    }
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    padding: '16px 24px 24px',
  },
  button: {
    padding: '8px 30px !important',
    fontSize: '14px !important',
    fontWeight: '500 !important',
    borderRadius: '42px !important',
    textTransform: 'none !important',
    minWidth: '80px',
  },
  cancelButton: {
    background: '#9e9e9e !important',
    color: 'white !important',
    '&:hover': {
      background: '#757575 !important',
    }
  },
  confirmButton: {
    background: '#f44336 !important',
    color: 'white !important',
    '&:hover': {
      background: '#d32f2f !important',
    }
  }
};

export default returnModalStyles
